
export default function (component: string, param?: string) {
    switch (component) {
        case "cust-cats":
            return import('../pages/profile/CategoriesPage.vue');
		case "postcode":
            return import('../pages/profile/PostcodePage.vue');
		case "region":
            return import('../pages/profile/RegionPage.vue');
		case "favorite-mail":
            return import('../pages/profile/FavoriteMailPage.vue');
		case "dynamic-attribute":
            return import('../pages/profile/DynamicAttributePage.vue');
		case "pref":
            return import('../pages/profile/PrefPage.vue');
		case "mail-account":
            return import('../pages/profile/MailAccountPage.vue');
		case "sms-account":
            return import('../pages/profile/SMSAccountPage.vue');
		case "send-mail":
            return import('../pages/mail/SendMailPage.vue');
		case "worksheet-setting":
            return import('../pages/profile/WorksheetSettingPage.vue');
		case "loginfo":
            return import('../pages/profile/LogInfoPage.vue');
		case "party-merge":
            return import('../pages/addressbook/PartyMergePage.vue');
		case "bulk-changes":
            return import('../pages/agenda/BulkChangesPage.vue');
		/* Row Objects */
		case "party":
			return import('../pages/addressbook/PartyPage.vue');
		case "event":
			return import('../pages/today/EventPage.vue');
		default:
			return import('./UnknownPageComponent.vue');
    }
};